import type { Person, Store, Weekday } from '../../domain/types.js';
import { HOUSEHOLD } from '../../data/index.js';

/** How much cooking a weeknight can actually absorb. */
export type Effort = 'low' | 'medium' | 'high';

export interface Settings {
  people: Person[];
  effort: Record<Weekday, Effort>;
  defaultStore: Store;
  /**
   * Settings are the ONE deliberate exception to per-item merge: the whole
   * object is last-write-wins. Per-field merge on a nested weekday-effort map
   * is real complexity, and both adults editing household composition while
   * simultaneously offline is not a scenario that occurs. The cost is
   * understood and accepted — if it ever did happen, one of the two edits
   * would be lost. Everything else in the system merges per item.
   */
  updatedAt?: string;
  updatedBy?: string;
}

/**
 * Derived from the household's real working week. Both adults work Wednesday
 * and Thursday and the twins are collected from nursery, so those are the
 * nights a plan collapses into a takeaway. Friday is the opposite: Peter is at
 * home, Emily is off, the twins are out until teatime — the batch-cook night.
 */
export const DEFAULT_SETTINGS: Settings = {
  people: HOUSEHOLD,
  effort: {
    mon: 'high',
    tue: 'medium',
    wed: 'low',
    thu: 'low',
    fri: 'high',
    sat: 'medium',
    sun: 'medium',
  },
  defaultStore: 'aldi',
};
